import React, {useState, useEffect} from 'react'
import { AuthContext } from './AuthContext';
import { Navigate } from 'react-router-dom';

function UserRoute({children}) {
    const [redirect, setRedirect] = useState(false);

    const token = localStorage.getItem("token") ? localStorage.getItem("token"): null;
    useEffect(() => {
        if (!token) {
          alert("You are not authorized to access this page. Please log in.");
          setTimeout(() => {
            setRedirect(true);
          }, 1500); // Delay to allow popup to show
        }
      }, [token]);
  
    
      
      if(token) return children;
      if(redirect) return <Navigate to="/signin" />;
      return null; // Render nothing while redirecting
  
}

export default UserRoute
